import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Base, CrossIcon } from '@itsrever/design-system'
import { useAppSelector } from '@/redux/hooks'
import { createPortal } from 'react-dom'
import posthog from 'posthog-js'

const { Button } = Base

export const NewReturnButton = () => {
  const { t } = useTranslation()

  const [openPortal, setOpenPortal] = useState(false)

  const ecommerceId = useAppSelector(
    (s) => s.settingsApi.settings.response.slug
  )

  const onButtonClick = () => {
    setOpenPortal(true)
    posthog?.capture('New-return button clicked')
  }

  return (
    <>
      <Button onClick={onButtonClick} variant="secondary">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 3.25H16C16.1989 3.25 16.3897 3.32902 16.5303 3.46967C16.671 3.61032 16.75 3.80109 16.75 4V16C16.75 16.1989 16.671 16.3897 16.5303 16.5303C16.3897 16.671 16.1989 16.75 16 16.75H4C3.80109 16.75 3.61032 16.671 3.46967 16.5303C3.32902 16.3897 3.25 16.1989 3.25 16V4C3.25 3.80109 3.32902 3.61032 3.46967 3.46967C3.61032 3.32902 3.80109 3.25 4 3.25V3.25ZM4.75 4.75V15.25H15.25V4.75H4.75ZM9.25 9.25V6.25H10.75V9.25H13.75V10.75H10.75V13.75H9.25V10.75H6.25V9.25H9.25Z"
            fill="#525866"
          />
        </svg>
        {t('orders.new_return')}
      </Button>
      {openPortal &&
        createPortal(
          <div
            className="absolute left-0 top-0 z-10 size-full bg-white"
            id="portal"
          >
            <button
              className="absolute left-5 top-5 rounded-lg bg-neutral-200/60 p-2 hover:bg-neutral-200"
              onClick={() => setOpenPortal(false)}
              aria-label={t('orders.close_portal')}
            >
              <CrossIcon />
            </button>
            <iframe
              src={`https://returns.itsrever.com/${ecommerceId}`}
              className="size-full"
            />
          </div>,
          document.getElementById('orders-page')!
        )}
    </>
  )
}
